import React from "react";
import Header from "../header/Header";
import VTStageDisplay from "../page/VTStageDisplay";

export default function LandingStageDisplay({page}) {
    return (
        <>
            <Header/>
            <VTStageDisplay/>
            {/*<Footer/>*/}
        </>
    );
}